// inputs.js
import {
  validateRequired, validateLength, validateNonZeroInteger, validateInteger,
  validateEmail, validateNotNull, validateIntLength,
  validateSelectInteger,
} from "../../../../helpers/validationsForm";

const Inputs = [

  {
    id: 1,
    label: "Codigo",
    name: "cli_codigo",
    type: "int",
    placeholder: "Ingrese el codigo",
      readOnly: true,
      disable: true,
 
  },
  {
    id: 2,
    label: "Razon Social",
    name: "razon_social",
    type: "text",
    placeholder: "Ingrese la razon social",
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateRequired(value);
      if (requiredError) {
        return requiredError;
      }

      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 3, maxLength: 60 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 3,
    label: "Nombre de Fantasia",
    name: "cli_name",
    type: "text",
    placeholder: "Ingrese el nombre de fantasia",
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateRequired(value);
      if (requiredError) {
        return requiredError;
      }

      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 3, maxLength: 60 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },

  {
    id: 4,
    label: "Tipo De IVA*",
    name: "tipoiva_id",
    type: "select",
    value: "",
    options: [],
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateNotNull(value);
      if (requiredError) {
        return requiredError;
      }

      // Validación de longitud
      const lengthError = validateNonZeroInteger(value);
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 5,
    label: "Tipo De Documento*",
    name: "td_id",
    type: "select",
    value: "",
    options: [],
    validation: (value, form) => {
      // Validación requerida
      const selectError = validateSelectInteger(value);
      if (selectError) {
        return selectError;
      }
 
      // Si no hay errores
      return null;
    }
  },
  {
    id: 6,
    label: "N° de Documento",
    name: "cli_cuit",
    type: "text",
    placeholder: "Ingrese el n° de documento",
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateNotNull(value);
      if (requiredError) {
        return requiredError;
      }

      // Validación de longitud
      const lengthError = validateInteger(value);
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },

  {
    id: 7,
    label: "Telefono",
    name: "cli_tel",
    type: "text",
    placeholder: "Ingrese la telefono",
    validation: (value, form) => {
      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 3, maxLength: 40 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },

  {
    id: 8,
    label: "Telefono Alternativo",
    name: "cli_tel_entrega",
    type: "text",
    placeholder: "Ingrese la telefono",
    validation: (value, form) => {
      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 3, maxLength: 40 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },

  {
    id: 9,
    label: "Correo Principal(USUARIO WEB)",
    name: "cli_mail",
    type: "text",
    readOnly: true,
    placeholder: "Ingrese el correo",
   
  },

  {
    id: 10,
    label: "Correo Altervativo",
    name: "cli_mail_entrega",
    type: "text",
    placeholder: "Ingrese el correo de entrega",
    validation: (value, form) => {
      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 3, maxLength: 40 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 11,
    label: "Categoria ",
    name: "categ_id",
    type: "select",
    validation: (value, form) => {
      

      // Si no hay errores
      return null;
    }
  },
  {
    id: 12,
    label: "Lista de Precio",
    name: "lp_id",
    type: "select",
    value: "",
    validation: (value, form) => {
      // Validación de longitud
      const integerError = validateInteger(value);
      if (integerError) {
        return integerError;
      }

      // Si no hay errores
      return null;
    }
  },

  {
    id: 13,
    label: "Maximo Descuento",
    name: "cli_maxporcdescto",
    type: "float",
    value: "",
    validation: (value, form) => {
      // Validación de longitud
      const integerError = validateInteger(value);
      if (integerError) {
        return integerError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 14,
    label: "Vendedor",
    name: "sel_id",
    type: "select",
    value: "",
    validation: (value, form) => {
      // Validación de longitud
      const integerError = validateInteger(value);
      if (integerError) {
        return integerError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 15,
    label: "Usuario Web",
    name: "cli_mail",
    type: "text",
    placeholder: "Ingrese el usuario",
    validation: (value, form) => {
      // Validación de longitud
      const emailError = validateEmail(value);
      if (emailError) {
        return emailError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 16,
    label: "Contraseña Web",
    name: "pass",
    type: "text",
    placeholder: "Ingrese la contraseña",
    validation: (value, form) => {
      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 8, maxLength: 12 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
   {
    id: 17,
    label: "Permitir Edicion de Datos",
    name: "cli_allow_edit",
    type: "select",
    options: [
      { value: 0, label: 'Solo Datos de Envio' },
      { value: 1, label: 'Incluir GPS' },
      //{ value: 2, label: 'Incluir Datos Fiscales' },
    ],
    placeholder: "Ingrese el tipo de visualización",
  },
  {
    id: 18,
    label: "Provincia",
    name: "pcia_id",
    type: "select",
    validation: (value, form) => {
      // Validación de longitud
      const integerError = validateInteger(value);
      if (integerError) {
        return integerError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 19,
    label: "Departamento",
    name: "depto_id",
    type: "select",
    validation: (value, form) => {
      // Validación de longitud
      const integerError = validateInteger(value);
      if (integerError) {
        return integerError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 20,
    label: "Localidad",
    name: "loc_id",
    type: "select",
    validation: (value, form) => {
      // Validación de longitud
      const integerError = validateInteger(value);
      if (integerError) {
        return integerError;
      }

      // Si no hay errores
      return null;
    }
  },

  {
    id: 21,
    label: "Barrio",
    name: "barrio_id",
    type: "select",
    validation: (value, form) => {
      // Validación de longitud
      const integerError = validateInteger(value);
      if (integerError) {
        return integerError;
      }

      // Si no hay errores
      return null;
    }
  },

  {
    id: 22,
    label: "Direccion",
    name: "cli_direccion",
    type: "text",
    placeholder: "Ingrese la dirección",
    
  },
  {
    id: 23,
    label: "N° de Calle",
    name: "cli_nro_calle",
    type: "text",
    placeholder: "Ingrese el número de calle",
     
  },
  {
    id: 24,
    label: "Piso",
    name: "cli_piso",
    type: "text",
    placeholder: "Ingrese el piso", 
  }, 
  {
    id: 25,
    label: "Departamento",
    name: "cli_dpto",
    type: "text",
    placeholder: "Ingrese el departamento", 
  },
  {
    id: 26,
    label: "Codigo Postal",
    name: "cli_cp",
    type: "text",
    placeholder: "Ingrese la codigo postal",
    validation: (value, form) => {
      // Validación de longitud
      const intLengthError = validateIntLength(value, { minLength: 4, maxLength: 4 });
      if (intLengthError) {
        return intLengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 27,
    label: "Observaciones",
    name: "cli_direccion_observ",
    type: "textarea",
    placeholder: "Ingrese observaciones sobre la dirección ",
    validation: (value, form) => {
      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 3, maxLength: 200 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },

  {
    id: 28,
    label: "Provincia",
    name: "cli_pcia_entrega",
    type: "select",
    validation: (value, form) => {
      // Validación de longitud
      const integerError = validateInteger(value);
      if (integerError) {
        return integerError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 29,
    label: "Departamento",
    name: "cli_depto_entrega",
    type: "select",
    validation: (value, form) => {
      // Validación de longitud
      const integerError = validateInteger(value);
      if (integerError) {
        return integerError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 30,
    label: "Localidad",
    name: "cli_loc_entrega",
    type: "select",
    validation: (value, form) => {
      // Validación de longitud
      const integerError = validateInteger(value);
      if (integerError) {
        return integerError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 31,
    label: "Barrio",
    name: "cli_barrio_entrega",
    type: "select",
    validation: (value, form) => {
      // Validación de longitud
      const integerError = validateInteger(value);
      if (integerError) {
        return integerError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 32,
    label: "Direccion de Entrega",
    name: "cli_direccion_entrega",
    type: "text",
    placeholder: "Ingrese la direccion de entrega",
     
  },
  {
    id: 33,
    label: "nro de Calle de Entrega",
    name: "cli_nro_calle_entrega",
    type: "text",
    placeholder: "Ingrese el número de calle",
    
  },
  {
    id: 34,
    label: "Piso Entrega",
    name: "cli_piso_entrega",
    type: "text",
    placeholder: "Ingrese el piso de entrega",
    
  },

  {
    id: 35,
    label: "Departamento",
    name: "cli_dpto_entrega",
    type: "text",
    placeholder: "Ingrese el departamento de entrega",
 
  },

  {
    id: 36,
    label: "Codigo Postal",
    name: "cli_cp_entrega",
    type: "text",
    placeholder: "Ingrese la codigo postal",
    validation: (value, form) => {
      // Validación de longitud
      const intLengthError = validateIntLength(value, { minLength: 4, maxLength: 4 });
      if (intLengthError) {
        return intLengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 37,
    label: "Observaciones",
    name: "cli_direccion_entrega_observ",
    type: "textarea",
    placeholder: "Ingrese observaciones sobre la dirección de entrega",
    validation: (value, form) => {
      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 3, maxLength: 200 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 38,
    label: "Latitud",
    name: "cli_gps_latitud",
    type: "text",
    placeholder: "Ingrese la latitud del cliente",
    
  },
  {
    id: 39,
    label: "Longitud",
    name: "cli_gps_longitud",
    type: "text",
    placeholder: "Ingrese la longitud del cliente",
  }

];

export default Inputs;
